<template>
  <div class="main-content">
    <div id="faq">
      <h3>Faq Page</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "Faq",
};
</script>

<style lang="scss" scoped>
@import "@/styles/imports";

#faq {
  padding: 24px;
  display: flex;
  flex: 1;
}
</style>
